export default "__VITE_ASSET__7b8zEWoV__"